module.exports = __webpack_public_path__ + "static/media/tortuga.17d32b3d.jpeg";